// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import IncomeInput from '../income';

const IncomeInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <IncomeInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default IncomeInputWithAnalytics;
